const INSPECT_LIMIT = 64 * 1024;
const AUTH_MESSAGE = '登录状态已失效，请重新登录后再下载';

export function isUnauthorizedPayload(payload) {
    return payload === 401 || payload === '401' || String(payload && payload.code) === '401';
}

function header(response, name) {
    const headers = response.headers || {};
    return String(typeof headers.get === 'function' ? headers.get(name) || ''
        : headers[name] || headers[Object.keys(headers).find(key => key.toLowerCase() === name)] || '');
}

function readText(blob) {
    if (typeof blob.text === 'function') return blob.text();
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = () => reject(reader.error);
        reader.readAsText(blob);
    });
}

export function downloadError(response, payload, fallback = '服务器未返回有效文件，请重试') {
    const unauthorized = response.status === 401 || isUnauthorizedPayload(payload);
    const message = unauthorized ? AUTH_MESSAGE
        : (payload && typeof payload === 'object' && (payload.message || payload.msg || payload.error)) || fallback;
    const error = new Error(typeof message === 'string' ? message : fallback);
    error.isAuthError = unauthorized;
    error.response = response;
    error.payload = payload;
    return error;
}

export async function inspectDownloadResponse(response) {
    const data = response.data;
    const blob = data instanceof Blob ? data : new Blob([data]);
    if (blob.size === 0) return downloadError(response, null, '服务器返回了空文件');
    const mime = (header(response, 'content-type') || blob.type).toLowerCase();
    const jsonMime = mime.includes('json');
    const htmlMime = mime.includes('text/html');
    const jsonAttachment = /attachment/i.test(header(response, 'content-disposition'))
        && /filename\*?=.*\.json(?:[";\s]|$)/i.test(header(response, 'content-disposition'));
    if (htmlMime) return downloadError(response, null, '下载接口返回了网页，而不是文件，请检查登录状态');
    // Inspect only a bounded prefix. XLSX/ZIP bytes are never decoded in full.
    let text = String(await readText(blob.slice(0, 512))).replace(/^\uFEFF/, '').trim();
    if (jsonMime || /^(?:\{|\[|"?401\b)/.test(text)) {
        text = String(await readText(blob.slice(0, INSPECT_LIMIT))).replace(/^\uFEFF/, '').trim();
    }
    let payload;
    try { payload = JSON.parse(text); } catch (error) { /* Normal binary/CSV files are not JSON. */ }
    if (isUnauthorizedPayload(payload)) return downloadError(response, payload);
    const envelope = payload && typeof payload === 'object' && !Array.isArray(payload)
        && ['code', 'message', 'msg', 'error', 'success'].some(key => Object.prototype.hasOwnProperty.call(payload, key));
    const failed = envelope && (Number(payload.code) >= 400 || payload.success === false || payload.error);
    if (envelope && (!jsonAttachment || failed)) return downloadError(response, payload);
    if (blob.size > INSPECT_LIMIT && /^\{/.test(text) && /"(?:code|message|msg|error|success)"\s*:/.test(text)
        && !jsonAttachment) return downloadError(response, null);
    if (jsonMime && (!jsonAttachment || payload === undefined)) return downloadError(response, payload);
    if (/^<(?:!doctype\s+html|html|head|body)\b/i.test(text)) {
        return downloadError(response, null, '下载接口返回了网页，而不是文件，请检查登录状态');
    }
    return null;
}
